module.exports = __webpack_public_path__ + "static/img/ent-44.ce723d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-44.jpg
// module id = iOVU
// module chunks = 52